import { AxiosInstance } from 'axios'
import axiosInstance from '@/api/index'
import i18n from '@/plugins/i18n'

export interface CGUDto {
  locale: string
  content: string
  updatedTime: string
}

class CGUApi {
  private axios: AxiosInstance

  public constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  public async fetchCGUMarkdown(saleId: number): Promise<CGUDto> {
    const locale = i18n.locale.toUpperCase()
    return (await this.axios.get('/cgu', {
      params: { locale, saleId },
    })).data
  }
}

export const cguApi = new CGUApi(axiosInstance)
